const COMPARE_STORAGE_KEY = 'gearCompareIds';
const COMPARE_CATEGORY_KEY = 'gearCompareCategory';
export const COMPARE_LIMIT = 5;

const readIds = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(COMPARE_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.map((id) => String(id)).filter(Boolean);
  } catch {
    return [];
  }
};

const writeIds = (ids = []) => {
  if (typeof window === 'undefined') return;
  const uniqueIds = Array.from(new Set(ids.map((id) => String(id)).filter(Boolean))).slice(0, COMPARE_LIMIT);
  window.localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(uniqueIds));
};

const readCategory = () => {
  if (typeof window === 'undefined') return '';
  try {
    return String(window.localStorage.getItem(COMPARE_CATEGORY_KEY) || '').trim();
  } catch {
    return '';
  }
};

const writeCategory = (category = '') => {
  if (typeof window === 'undefined') return;
  const nextCategory = String(category || '').trim();
  if (!nextCategory) {
    window.localStorage.removeItem(COMPARE_CATEGORY_KEY);
    return;
  }
  window.localStorage.setItem(COMPARE_CATEGORY_KEY, nextCategory);
};

export const getCompareIds = () => readIds();

export const getCompareCategory = () => readCategory();

export const isInCompare = (id) => readIds().includes(String(id));

export const addToCompare = (id, options = {}) => {
  const nextId = String(id || '').trim();
  const nextCategory = String(options.category || '').trim();
  if (!nextId) {
    return { ok: false, reason: 'invalid', ids: readIds() };
  }

  const ids = readIds();
  const currentCategory = readCategory();
  if (ids.length > 0 && currentCategory && nextCategory && currentCategory !== nextCategory) {
    return {
      ok: false,
      reason: 'incompatible',
      ids,
      compareCategory: currentCategory,
      incomingCategory: nextCategory
    };
  }

  if (ids.includes(nextId)) {
    return { ok: true, reason: 'exists', ids };
  }
  if (ids.length >= COMPARE_LIMIT) {
    return { ok: false, reason: 'limit', ids };
  }

  const nextIds = [...ids, nextId];
  writeIds(nextIds);
  if (nextCategory) {
    writeCategory(nextCategory);
  } else if (!currentCategory && nextIds.length > 0) {
    writeCategory('');
  }
  return { ok: true, reason: 'added', ids: nextIds };
};

export const removeFromCompare = (id) => {
  const target = String(id || '').trim();
  const nextIds = readIds().filter((itemId) => itemId !== target);
  writeIds(nextIds);
  if (nextIds.length === 0) {
    writeCategory('');
  }
  return nextIds;
};

export const clearCompare = () => {
  writeIds([]);
  writeCategory('');
};
